var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { styled } from "@mui/system";
import { d3ColorScales } from "../Utils/d3ColorScale";
import { ColorSelectorComponent } from "./ColorSelectorComponent";
import { RGBToHex } from "../Utils/legendCommonFunction";
var StyledParentDiv = styled("div")({
    display: "flex",
});
var StyledContentCopyIcon = styled("div")({
    "&:hover": {
        background: "#f1f1f1",
        cursor: "pointer",
    },
});
var StyledRangeParentContainer = styled("div")({
    height: 58,
    borderRadius: "0.5em",
    border: "1px solid #dadada",
});
var StyledRangeChildContainer = styled("div")({
    marginTop: 8,
    marginLeft: 13,
});
var StyledInterpolationParentContainer = styled("div")({
    height: 72,
    borderRadius: "0.5em",
    border: "1px solid #dadada",
});
var StyledInterpolationChildContainer = styled("div")({
    marginTop: 8,
    marginLeft: 13,
});
var StyledInterpolationLegendWrapper = styled("div")({
    height: 120,
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    overflowX: "hidden",
    marginLeft: -12,
});
export var ColorSelectorWrapper = function (_a) {
    var newColorScaleData = _a.newColorScaleData, colorTables = _a.colorTables, useRange = _a.useRange, getRange = _a.getRange, isCont = _a.isCont, useInterpolation = _a.useInterpolation, getInterpolation = _a.getInterpolation, currentLegendName = _a.currentLegendName, isCustomScale = _a.isCustomScale, getDuplicatedLegendData = _a.getDuplicatedLegendData, selectedInterpolationType = _a.selectedInterpolationType, selectedRangeType = _a.selectedRangeType;
    var continuousD3Legend;
    var discreteD3Legend;
    var continuousLegend;
    var discreteLegend;
    var continuosColorData = [];
    var continuosD3ColorData = [];
    var discreteColorData = [];
    var discreteD3ColorData = [];
    var _b = React.useState(true), isAuto = _b[0], setAuto = _b[1];
    // For altering data range
    var onChangeRange = React.useCallback(function (e) {
        if (e.value === "Auto") {
            getRange("Auto");
            setAuto(true);
        }
        else {
            setAuto(false);
            var inputValue1 = document.getElementById("minV").value;
            var inputValue2 = document.getElementById("maxV").value;
            getRange([parseFloat(inputValue1), parseFloat(inputValue2)]);
        }
    }, [getRange]);
    // For interpolation
    var onChangeInterpolation = React.useCallback(function (e) {
        if (e.value === "Logarithmic") {
            getInterpolation("Logarithmic");
        }
        else if (e.value === "Linear") {
            getInterpolation("Linear");
        }
        else {
            getInterpolation("Nearest");
        }
    }, [getInterpolation]);
    var _c = React.useState([]), duplicatedLegendData = _c[0], setDuplicatedLegendData = _c[1];
    var copyLegend = function (value) {
        var test = value.color.map(function (item) {
            return {
                position: item[0],
                color: RGBToHex(item).color,
                name: value.name,
            };
        });
        setDuplicatedLegendData(__spreadArray(__spreadArray([], duplicatedLegendData, true), [test], false));
        isCustomScale(value.name);
    };
    React.useEffect(function () {
        if (getDuplicatedLegendData) {
            getDuplicatedLegendData(duplicatedLegendData);
        }
    }, [
        duplicatedLegendData,
        duplicatedLegendData.length,
        getDuplicatedLegendData,
    ]);
    if (!useRange || !useInterpolation) {
        // Continuous legend using color table  data
        var colorTableContinuousData = colorTables === null || colorTables === void 0 ? void 0 : colorTables.filter(function (element) {
            return element.discrete === false;
        });
        colorTableContinuousData === null || colorTableContinuousData === void 0 ? void 0 : colorTableContinuousData.forEach(function (element) {
            continuosColorData.push({ color: element.colors, name: element.name });
        });
        // Continuous legend using d3 data
        var d3continuousData = d3ColorScales === null || d3ColorScales === void 0 ? void 0 : d3ColorScales.filter(function (element) {
            return element.discrete === false;
        });
        d3continuousData === null || d3continuousData === void 0 ? void 0 : d3continuousData.forEach(function (element) {
            continuosD3ColorData.push({ color: element.colors, name: element.name });
        });
        // Discrete legend using color table data
        var discreteData = colorTables === null || colorTables === void 0 ? void 0 : colorTables.filter(function (element) {
            return element.discrete === true;
        });
        discreteData === null || discreteData === void 0 ? void 0 : discreteData.forEach(function (element) {
            discreteColorData.push({ color: element.colors, name: element.name });
        });
        // Discrete legend using d3 data
        var d3discreteData = d3ColorScales === null || d3ColorScales === void 0 ? void 0 : d3ColorScales.filter(function (element) {
            return element.discrete === true;
        });
        d3discreteData === null || d3discreteData === void 0 ? void 0 : d3discreteData.forEach(function (element) {
            discreteD3ColorData.push({ color: element.colors, name: element.name });
        });
        // return continuous and discrete legend which uses d3 data
        continuousD3Legend = continuosD3ColorData.map(function (val, index) {
            return (React.createElement(ColorSelectorComponent, { legendColor: val.color, legendColorName: val.name, useContColorTable: false, uniqueId: index, colorScaleData: newColorScaleData, key: val.name, currentLegendName: currentLegendName }));
        });
        discreteD3Legend = d3discreteData.map(function (val) {
            return (React.createElement(ColorSelectorComponent, { colorsObject: val.colors, legendColorName: val.name, useDiscColorTable: false, colorScaleData: newColorScaleData, key: val.name, currentLegendName: currentLegendName }));
        });
        // return continuous and discrete legend which uses colortable data
        continuousLegend = continuosColorData.map(function (value, index) {
            return (React.createElement(StyledParentDiv, { key: value.name },
                React.createElement("div", null,
                    React.createElement(ColorSelectorComponent, { colorsObject: value, legendColorName: value.name, useContColorTable: true, uniqueId: index, colorScaleData: newColorScaleData, key: value.name, currentLegendName: currentLegendName })),
                React.createElement(StyledContentCopyIcon, { title: "Duplicate", style: { cursor: "pointer" } },
                    React.createElement(ContentCopyIcon, { fontSize: "small", color: "action", style: { marginTop: 5 }, onClick: function () { return copyLegend(value); } }))));
        });
        discreteLegend = discreteColorData.map(function (val, index) {
            return (React.createElement(ColorSelectorComponent, { colorsObject: discreteColorData[index], legendColorName: val.name, useDiscColorTable: true, colorScaleData: newColorScaleData, key: index, currentLegendName: currentLegendName }));
        });
    }
    // Sampling through range
    if (useRange) {
        return (React.createElement(StyledRangeParentContainer, { onChange: function (ev) {
                onChangeRange(ev.target);
            } },
            React.createElement(StyledRangeChildContainer, null,
                React.createElement("input", { type: "radio", value: "Auto", name: "range", disabled: !isCont, defaultChecked: selectedRangeType === null || selectedRangeType === void 0 ? void 0 : selectedRangeType.isAuto }),
                " ",
                "Auto ",
                React.createElement("br", null),
                React.createElement("input", { type: "radio", value: "Domain", name: "range", disabled: !isCont, defaultChecked: (selectedRangeType === null || selectedRangeType === void 0 ? void 0 : selectedRangeType.isAuto) === false }),
                React.createElement("label", { style: { marginLeft: 3, marginRight: 10 } }, "Min"),
                React.createElement("input", { type: "text", id: "minV", size: 3, disabled: isAuto || !isCont }),
                React.createElement("label", { style: { marginLeft: 10, marginRight: 10 } }, "Max"),
                React.createElement("input", { type: "text", id: "maxV", size: 3, disabled: isAuto || !isCont }))));
    }
    // Interpolation methods
    else if (useInterpolation) {
        return (React.createElement(StyledInterpolationParentContainer, { onChange: function (ev) {
                onChangeInterpolation(ev.target);
            } },
            React.createElement(StyledInterpolationChildContainer, null,
                React.createElement("input", { type: "radio", value: "Linear", name: "interpolation", disabled: !isCont, defaultChecked: selectedInterpolationType === null || selectedInterpolationType === void 0 ? void 0 : selectedInterpolationType.isLinear }),
                "Linear ",
                React.createElement("br", null),
                React.createElement("input", { type: "radio", value: "Logarithmic", name: "interpolation", disabled: !isCont, defaultChecked: selectedInterpolationType === null || selectedInterpolationType === void 0 ? void 0 : selectedInterpolationType.isLog }),
                "Logarithmic ",
                React.createElement("br", null),
                React.createElement("input", { type: "radio", value: "Nearest", name: "interpolation", disabled: !isCont, defaultChecked: selectedInterpolationType === null || selectedInterpolationType === void 0 ? void 0 : selectedInterpolationType.isNearest }),
                "Nearest ",
                React.createElement("br", null))));
    }
    return (React.createElement(StyledInterpolationLegendWrapper, null,
        continuousLegend,
        continuousD3Legend,
        discreteLegend,
        discreteD3Legend));
};
//# sourceMappingURL=ColorSelectorWrapper.js.map